import { createContext, type RefObject } from 'react';
import type { PcaMapContextProviderProps } from './PcaMapContextProvider';
import { Google } from '../../app-kit/components/PcaMap/types';

export interface PcaMapState {
  ref?: RefObject<HTMLDivElement | null>;
  map?: google.maps.Map;
  google?: Google;
  initialConfig?: Readonly<PcaMapContextProviderProps>;
  isLoading: boolean;
}

export const PcaMapContext = createContext<PcaMapState>({
  isLoading: true,
});
